import COLORS from '../../../../../../../theme/colors';

import { LargeCheckbox } from './icons';

type DoneStepBodyProps = {
  domain: string;
};

export const DoneStepBody = ({ domain }: DoneStepBodyProps) => (
  <>
    <div className="text-center margin-bottom-xl">
      <LargeCheckbox fillColor={COLORS.fossaGreen} />
    </div>
    <p>
      <span className="bold">{domain}</span> is now configured for your organization.
      Anyone with a <span className="italic">@{domain}</span> account will now be able to access FOSSA without having to
      create or manage a separate FOSSA organization.
    </p>
  </>
);
